import { SvgIcon, SvgIconProps } from "@mui/material";

export const NoGroupsFigures = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "158", height: "121", fill: "none" }}
      width="158"
      height="121"
      viewBox="0 0 158 121"
      fill="none"
    >
      <path
        d="M128.497 22.0288H44.5994V80.8608H128.497V22.0288Z"
        fill="#E7E7E7"
      />
      <path
        d="M88.3972 27.541H51.7017V72.8237H88.3972V27.541Z"
        fill="#CFCFCF"
      />
      <g opacity="0.39">
        <path
          d="M75.5318 34.6328H71.9768V35.7656H75.5318V34.6328Z"
          fill="#F5F6F5"
        />
        <path
          d="M85.628 34.6328H76.7405V35.7656H85.628V34.6328Z"
          fill="#F5F6F5"
        />
        <path
          d="M80.8288 38.2944H71.9768V39.4272H80.8288V38.2944Z"
          fill="#F5F6F5"
        />
        <path
          d="M85.628 38.2944H81.9663V39.4272H85.628V38.2944Z"
          fill="#F5F6F5"
        />
        <path
          d="M85.6281 41.9561H76.4207V43.0888H85.6281V41.9561Z"
          fill="#F5F6F5"
        />
        <path
          d="M75.4252 41.9561H71.9768V43.0888H75.4252V41.9561Z"
          fill="#F5F6F5"
        />
        <path
          d="M82.5352 45.6133H71.9768V46.746H82.5352V45.6133Z"
          fill="#F5F6F5"
        />
      </g>
      <path
        opacity="0.39"
        d="M68.6708 34.6328H54.7036V50.1804H68.6708V34.6328Z"
        fill="#F5F6F5"
      />
      <path
        d="M88.3972 27.541H51.7017V31.6892H88.3972V27.541Z"
        fill="#106048"
      />
      <path
        opacity="0.39"
        d="M85.6282 54.0015H73.6123V55.0465H85.6282V54.0015Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M72.1903 54.0015H54.7036V55.0465H72.1903V54.0015Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M85.6282 58.0142H77.0962V59.0592H85.6282V58.0142Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M75.3898 58.0142H54.7036V59.0592H75.3898V58.0142Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M65.2264 62.0264H54.7036V63.0714H65.2264V62.0264Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M85.6281 62.0264H68.0703V63.0714H85.6281V62.0264Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M81.6466 66.0391H54.7036V67.0841H81.6466V66.0391Z"
        fill="#F5F6F5"
      />
      <path
        d="M63.8162 38.9843C63.8162 38.9843 64.3337 41.4852 64.1085 43.2203C64.0867 43.3881 64.0322 43.5498 63.9482 43.6963C63.8642 43.8428 63.7523 43.971 63.6191 44.0737C63.4858 44.1764 63.3338 44.2514 63.1717 44.2946C63.0097 44.3377 62.8407 44.3481 62.6747 44.3251C61.8136 44.1975 60.6997 43.7747 60.2454 42.4664L59.25 40.3325C59.0911 39.8855 59.0738 39.3997 59.2005 38.9423C59.3272 38.4849 59.5916 38.0787 59.9571 37.7798C61.225 36.5912 63.595 37.4368 63.8162 38.9843Z"
        fill="#F4A28C"
      />
      <path
        d="M59.416 40.7192L59.0881 49.0913L63.6701 48.9438L62.0664 42.913L59.416 40.7192Z"
        fill="#F4A28C"
      />
      <path
        d="M63.1999 39.1597C62.4267 39.2825 61.642 39.3146 60.8615 39.2555C61.1256 39.5745 61.2919 39.9643 61.3403 40.3772C61.3887 40.7901 61.3171 41.2083 61.1341 41.5808C60.9627 41.9431 60.6721 42.2342 60.312 42.4044C59.9518 42.5746 59.5444 42.6134 59.1591 42.5141L58.8154 39.2475C58.7524 38.782 58.8145 38.3079 58.9952 37.875C59.1758 37.442 59.4685 37.0661 59.8424 36.7865C60.1679 36.5443 60.5083 36.3231 60.8615 36.1244C61.7463 35.6378 63.1802 36.1005 63.9425 35.3666C64.019 35.293 64.1132 35.2409 64.2157 35.2153C64.3182 35.1896 64.4255 35.1914 64.5272 35.2204C64.6288 35.2494 64.7212 35.3046 64.7953 35.3805C64.8694 35.4565 64.9226 35.5507 64.9498 35.6537C65.2105 36.627 65.2184 38.2104 63.9544 38.9124C63.7184 39.0371 63.4634 39.1207 63.1999 39.1597Z"
        fill="#111111"
      />
      <path
        d="M61.4028 41.4731C61.4028 41.4731 61.2685 40.4958 60.5496 40.6753C59.8307 40.8548 60.0164 42.2468 61.0197 42.2708L61.4028 41.4731Z"
        fill="#F4A28C"
      />
      <path
        d="M64.0612 40.5796L64.8788 41.477C64.9276 41.5266 64.9625 41.5882 64.9803 41.6558C64.998 41.7233 64.9978 41.7943 64.9798 41.8617C64.9618 41.9292 64.9266 41.9907 64.8777 42.0401C64.8288 42.0894 64.7679 42.125 64.7011 42.1431L63.761 42.4423L64.0612 40.5796Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M62.4733 44.2173C61.8893 44.1416 61.34 43.8948 60.8933 43.5073C60.8933 43.5073 61.1382 45.023 62.971 46.3273L62.4733 44.2173Z"
        fill="#CE8172"
      />
      <path
        d="M60.1783 47.7871H63.2C63.4557 47.7871 63.709 47.838 63.9452 47.9368C64.1815 48.0356 64.3962 48.1805 64.577 48.363C64.7578 48.5456 64.9013 48.7624 64.9991 49.001C65.097 49.2396 65.1474 49.4953 65.1474 49.7535V50.1922H58.2349V49.7535C58.2349 49.4953 58.2852 49.2396 58.3831 49.001C58.481 48.7624 58.6244 48.5456 58.8052 48.363C58.9861 48.1805 59.2007 48.0356 59.437 47.9368C59.6733 47.838 59.9265 47.7871 60.1822 47.7871H60.1783Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M125.215 38.4058H95.27V75.3523H125.215V38.4058Z"
        fill="#111111"
      />
      <path
        d="M122.308 34.7402H92.3628V71.6867H122.308V34.7402Z"
        fill="#CFCFCF"
      />
      <g opacity="0.39">
        <path
          d="M111.805 40.5278H108.906V41.4492H111.805V40.5278Z"
          fill="#F5F6F5"
        />
        <path
          d="M120.044 40.5278H112.792V41.4492H120.044V40.5278Z"
          fill="#F5F6F5"
        />
        <path
          d="M116.126 43.5151H108.906V44.4365H116.126V43.5151Z"
          fill="#F5F6F5"
        />
        <path
          d="M120.041 43.5151H117.054V44.4365H120.041V43.5151Z"
          fill="#F5F6F5"
        />
        <path
          d="M120.045 46.5029H112.532V47.4243H120.045V46.5029Z"
          fill="#F5F6F5"
        />
        <path
          d="M111.718 46.5029H108.906V47.4243H111.718V46.5029Z"
          fill="#F5F6F5"
        />
        <path
          d="M117.52 49.4902H108.906V50.4116H117.52V49.4902Z"
          fill="#F5F6F5"
        />
      </g>
      <path
        opacity="0.39"
        d="M106.211 40.5278H94.8118V53.2156H106.211V40.5278Z"
        fill="#F5F6F5"
      />
      <path
        d="M122.308 34.7402H92.3628V38.1266H122.308V34.7402Z"
        fill="#106048"
      />
      <path
        opacity="0.39"
        d="M120.044 56.3345H110.24V57.188H120.044V56.3345Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M109.083 56.3345H94.8118V57.188H109.083V56.3345Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M120.04 59.6055H113.081V60.459H120.04V59.6055Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M111.69 59.6055H94.8118V60.459H111.69V59.6055Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M103.395 62.8799H94.8118V63.7334H103.395V62.8799Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M120.041 62.8799H105.714V63.7334H120.041V62.8799Z"
        fill="#F5F6F5"
      />
      <path
        opacity="0.39"
        d="M116.797 66.1548H94.8118V67.0083H116.797V66.1548Z"
        fill="#F5F6F5"
      />
      <path
        d="M102.992 43.934C103.237 45.1338 103.322 46.3611 103.245 47.5836C103.226 47.7279 103.178 47.8669 103.106 47.9927C103.033 48.1185 102.936 48.2287 102.822 48.3168C102.707 48.405 102.576 48.4694 102.436 48.5065C102.297 48.5436 102.152 48.5525 102.009 48.5328C101.545 48.4985 101.1 48.3297 100.729 48.0467C100.358 47.7637 100.075 47.3786 99.9152 46.9374L99.0423 45.1026C98.9093 44.7171 98.8967 44.2996 99.0062 43.9066C99.1157 43.5135 99.342 43.1639 99.6545 42.9049C100.772 41.8679 102.787 42.6058 102.992 43.934Z"
        fill="#F4A28C"
      />
      <path
        d="M99.2001 45.4336L98.9197 52.641L102.866 52.5174L101.487 47.3202L99.2001 45.4336Z"
        fill="#F4A28C"
      />
      <path
        d="M103.202 45.3062L103.905 46.076C103.945 46.1196 103.973 46.1728 103.987 46.2306C104.001 46.2884 104.001 46.3488 103.985 46.4062C103.97 46.4636 103.94 46.5162 103.899 46.5589C103.858 46.6016 103.807 46.633 103.751 46.6503L102.961 46.9096L103.202 45.3062Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M101.835 48.4452C101.334 48.3786 100.864 48.1666 100.48 47.835C100.48 47.835 100.69 49.1392 102.266 50.26L101.835 48.4452Z"
        fill="#CE8172"
      />
      <path
        d="M102.866 42.973C102.866 42.973 102.866 45.418 100.618 45.4738C100.658 45.4738 100.539 46.826 100.532 46.8938C100.413 47.8311 100.654 48.7924 100.634 49.7496C100.644 49.9152 100.61 50.0804 100.536 50.2283C100.411 50.3862 100.237 50.4972 100.042 50.5434C98.9585 50.9018 97.8017 50.9706 96.6843 50.7428C96.5269 50.7333 96.3742 50.685 96.2396 50.602C96.105 50.5191 95.9926 50.4041 95.9123 50.2671C95.8319 50.13 95.7861 49.9752 95.7789 49.8162C95.7716 49.6571 95.8031 49.4987 95.8706 49.3548C95.9567 48.8079 96.1037 48.2727 96.309 47.7593C96.4907 47.2966 96.7672 46.8778 96.945 46.4231C97.3367 45.3962 97.602 44.3245 97.735 43.2322C97.7634 42.8992 97.8324 42.571 97.9404 42.255C98.1316 41.8189 98.426 41.4368 98.7975 41.1422C99.1669 40.8636 99.6266 40.7355 100.085 40.7832C102.483 40.7354 103.056 41.7764 102.866 42.973Z"
        fill="#111111"
      />
      <path
        d="M100.911 46.0799C100.911 46.0799 100.796 45.2423 100.176 45.3819C99.5558 45.5215 99.7177 46.734 100.571 46.746L100.911 46.0799Z"
        fill="#F4A28C"
      />
      <path
        d="M103.786 53.2754H97.7665V53.1637C97.7665 52.6348 97.9746 52.1275 98.345 51.7535C98.7154 51.3795 99.2177 51.1694 99.7415 51.1694H101.839C102.363 51.1694 102.865 51.3795 103.236 51.7535C103.606 52.1275 103.814 52.6348 103.814 53.1637V53.2754H103.786Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M43.0551 51.0301C43.3343 50.908 43.6206 50.8028 43.9122 50.715C45.3409 50.3303 46.8142 50.1412 48.2928 50.1526C50.6628 50.0848 53.3567 50.1845 55.6003 51.0261C57.7254 51.8238 58.9775 53.8181 59.7438 55.8722C59.9848 56.5144 60.0914 56.9731 60.8933 56.8614C63.5449 56.4878 66.0513 55.4116 68.1573 53.7423C70.0573 52.2267 71.7123 50.1885 74.0547 49.5862C74.2373 49.5286 74.4329 49.5286 74.6156 49.5862C74.9276 49.7059 75.0382 50.0967 75.0659 50.4318C75.1158 51.6334 74.7911 52.8206 74.1376 53.8261C73.4872 54.8226 72.7481 55.7571 71.9296 56.6181C69.5003 59.3583 67.1896 62.2979 64.0296 64.1965C63.5468 64.418 63.1408 64.7806 62.8643 65.2375C62.2995 66.5059 62.8406 78.9344 62.8643 81.0204H48.6443L42.0715 63.9532C40.8865 60.8979 38.1215 56.3748 40.3217 53.2079C41.0105 52.2356 41.9583 51.4804 43.0551 51.0301Z"
        fill="#111111"
      />
      <path
        d="M26.9153 81.9136C26.9153 81.9136 27.2352 86.6999 29.4749 85.4435C31.7145 84.1871 28.91 81.9136 28.91 81.9136H26.9153Z"
        fill="#F4A28C"
      />
      <path
        d="M33.8239 50.918C33.8239 50.918 17.9607 62.3055 26.544 81.9135H28.914C28.914 81.9135 27.6698 67.702 33.8239 60.9533C39.978 54.2046 33.8239 50.918 33.8239 50.918Z"
        fill="#106048"
      />
      <path
        opacity="0.2"
        d="M33.8239 50.918C33.8239 50.918 17.9607 62.3055 26.544 81.9135H28.914C28.914 81.9135 27.6698 67.702 33.8239 60.9533C39.978 54.2046 33.8239 50.918 33.8239 50.918Z"
        fill="white"
      />
      <path
        d="M38.153 44.772L39.5039 48.8643L36.2965 50.9184L35.1431 43.8267L38.153 44.772Z"
        fill="#F4A28C"
      />
      <path
        d="M34.2031 41.3774C34.3328 41.0691 34.5372 40.7988 34.7976 40.5913C35.0579 40.3839 35.3658 40.2459 35.6929 40.1903C36.0199 40.1347 36.3556 40.1631 36.6689 40.273C36.9822 40.3828 37.2631 40.5706 37.4856 40.819C38.556 41.9756 39.8556 43.8144 38.3862 44.8076C36.1465 46.3392 34.0925 43.4794 34.0925 43.4794C33.9246 42.7829 33.9631 42.0519 34.2031 41.3774Z"
        fill="#F4A28C"
      />
      <path
        d="M36.1268 42.3827C36.1268 42.3827 35.396 41.7684 35.0642 42.6419C34.7324 43.5154 36.0241 43.9422 36.4072 43.4995C36.7904 43.0567 36.1268 42.3827 36.1268 42.3827Z"
        fill="#F4A28C"
      />
      <path
        d="M37.8159 70.0603L22.1489 74.1377L24.9643 85.1681L40.6313 81.0907L37.8159 70.0603Z"
        fill="#707070"
      />
      <path
        opacity="0.08"
        d="M30.2769 71.8143L32.7851 79.269L32.6508 82.9426L36.2493 82.0172L37.849 75.3961L33.4882 70.9688L30.2769 71.8143Z"
        fill="#111111"
      />
      <path
        d="M32.556 52.9442C33.0398 51.8612 33.7489 50.896 34.6349 50.1141C35.5209 49.3323 36.5632 48.7522 37.691 48.4132C42.036 47.0929 50.0663 48.5368 52.5114 52.6531C55.861 58.285 50.959 76.1859 50.959 76.1859L36.3401 77.3067C36.3401 77.3067 28.2742 62.6405 32.556 52.9442Z"
        fill="#106048"
      />
      <path
        d="M50.9629 76.1621L49.0393 101.574H45.9938L43.2762 81.8299L36.5454 77.3068L50.9629 76.1621Z"
        fill="#111111"
      />
      <path
        d="M36.5453 77.3066L32.3464 101.573H35.6091L42.6599 81.4149L36.5453 77.3066Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M38.9588 48.0063C38.9588 48.0063 32.1134 70.2788 51.8871 71.7545L50.9549 76.162L36.3399 77.3067C36.3399 77.3067 31.1812 69.13 31.4024 57.6428C31.4024 57.6428 31.5249 51.963 35.4867 49.4502C36.5291 48.7249 37.7129 48.2327 38.9588 48.0063Z"
        fill="#111111"
      />
      <path
        d="M33.109 101.521L31.134 102.985C31.0551 103.038 30.9953 103.115 30.964 103.205C30.9327 103.295 30.9316 103.392 30.9608 103.483C30.99 103.574 31.0479 103.652 31.1256 103.706C31.2032 103.761 31.2964 103.788 31.3907 103.783H34.685C34.7992 103.783 34.9087 103.737 34.9895 103.656C35.0702 103.574 35.1156 103.464 35.1156 103.348V101.533L33.109 101.521Z"
        fill="#106048"
      />
      <path
        d="M48.6561 101.521L50.5087 102.985C50.5857 103.04 50.6432 103.118 50.6724 103.208C50.7017 103.299 50.7011 103.396 50.6708 103.486C50.6405 103.576 50.5822 103.653 50.5045 103.707C50.4268 103.761 50.334 103.787 50.2401 103.783H47.8938C47.5617 103.783 47.2432 103.65 47.0083 103.413C46.7735 103.176 46.6416 102.854 46.6416 102.519V101.533L48.6561 101.521Z"
        fill="#106048"
      />
      <path
        d="M34.286 44.3449C34.286 44.3449 35.001 45.6532 36.182 45.2463C37.3631 44.8395 36.5138 42.0235 36.5138 42.0235C36.5138 42.0235 37.9437 39.9415 37.7383 38.2942C37.7048 38.099 37.6103 37.9198 37.4688 37.7827C37.3273 37.6456 37.146 37.5577 36.9516 37.5319C36.7571 37.506 36.5596 37.5436 36.3877 37.6391C36.2159 37.7347 36.0788 37.8831 35.9964 38.0628C35.8613 38.3145 35.6634 38.5261 35.4222 38.6766C35.1811 38.827 34.9051 38.9111 34.6218 38.9204C32.6112 39.1437 30.7666 42.3506 34.286 44.3449Z"
        fill="#111111"
      />
      <path
        d="M48.4506 49.3545C48.4506 49.3545 58.0215 54.787 61.0037 54.787C63.986 54.787 71.4278 49.1191 71.4278 49.1191L73.0078 52.4297C73.0078 52.4297 66.6878 62.3773 61.0393 61.6035C55.3908 60.8297 46.6494 55.8559 46.6494 55.8559L48.4506 49.3545Z"
        fill="#106048"
      />
      <path
        d="M71.4277 49.1314C71.4277 49.1314 72.8221 46.2317 73.2842 46.2676C73.7464 46.3035 73.5686 47.2368 73.5686 47.2368C73.5686 47.2368 75.0617 45.5496 75.4883 45.8009C75.9149 46.0522 75.9505 49.8214 72.9998 52.442L71.4277 49.1314Z"
        fill="#F4A28C"
      />
      <path
        d="M128.497 16.752H44.5994V22.0289H128.497V16.752Z"
        fill="#111111"
      />
      <path
        d="M52.3929 20.7725C53.1499 20.7725 53.7635 20.1528 53.7635 19.3884C53.7635 18.6241 53.1499 18.0044 52.3929 18.0044C51.6359 18.0044 51.0222 18.6241 51.0222 19.3884C51.0222 20.1528 51.6359 20.7725 52.3929 20.7725Z"
        fill="white"
      />
      <path
        d="M56.4732 20.7725C57.2302 20.7725 57.8438 20.1528 57.8438 19.3884C57.8438 18.6241 57.2302 18.0044 56.4732 18.0044C55.7162 18.0044 55.1025 18.6241 55.1025 19.3884C55.1025 20.1528 55.7162 20.7725 56.4732 20.7725Z"
        fill="#106048"
      />
      <path
        d="M60.3165 20.7725C61.0734 20.7725 61.6871 20.1528 61.6871 19.3884C61.6871 18.6241 61.0734 18.0044 60.3165 18.0044C59.5595 18.0044 58.9458 18.6241 58.9458 19.3884C58.9458 20.1528 59.5595 20.7725 60.3165 20.7725Z"
        fill="#111111"
      />
      <path
        opacity="0.2"
        d="M122.304 27.541H93.1094V30.7877H122.304V27.541Z"
        fill="white"
      />{" "}
    </SvgIcon>
  );
};

export const BackToGroupIconBtn = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 12H5M5 12L11 6M5 12L11 18"
        stroke="#111111"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const WhyCreateBtnIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.87538 14.1249L14.125 5.87531M14.125 5.87531L7.05389 5.87531M14.125 5.87531L14.125 12.9464"
        stroke="#106048"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const FallBackGroupIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "79", height: "78", fill: "none" }}
      width="79"
      height="78"
      viewBox="0 0 79 78"
      fill="none"
    >
      <rect x="1" y="0.5" width="77" height="77" rx="38.5" fill="#F5F6F5" />
      <rect x="1" y="0.5" width="77" height="77" rx="38.5" stroke="#F3F5F5" />
      <path
        d="M33.4996 47.0004L42.3686 38.1314C42.7646 37.7354 42.9627 37.5373 43.191 37.4632C43.3918 37.3979 43.6082 37.3979 43.809 37.4632C44.0373 37.5373 44.2354 37.7354 44.6314 38.1314L48.9053 42.4053M38 35.5C38 36.6046 37.1046 37.5 36 37.5C34.8954 37.5 34 36.6046 34 35.5C34 34.3954 34.8954 33.5 36 33.5C37.1046 33.5 38 34.3954 38 35.5ZM49.5 39C49.5 44.5228 45.0228 49 39.5 49C33.9772 49 29.5 44.5228 29.5 39C29.5 33.4772 33.9772 29 39.5 29C45.0228 29 49.5 33.4772 49.5 39Z"
        stroke="#A0A0A0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const EditGroupMediaIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "26", height: "26", fill: "none" }}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="24.3333"
        height="24.3333"
        rx="12.1667"
        fill="#106048"
      />
      <rect
        x="0.5"
        y="0.5"
        width="24.3333"
        height="24.3333"
        rx="12.1667"
        stroke="white"
      />
      <path
        d="M15.1058 7.32746C15.7644 6.66884 16.8322 6.66884 17.4908 7.32746L17.8402 6.97807L17.4908 7.32746L18.0062 7.84282C18.6648 8.50144 18.6648 9.56928 18.0062 10.2279L10.3872 17.8469L6.86525 18.4684L7.48677 14.9465L15.1058 7.32746Z"
        fill="white"
        stroke="#106048"
      />
    </SvgIcon>
  );
};

export const NoMembersInGroupFigure = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "74", height: "74", fill: "none" }}
      width="74"
      height="74"
      viewBox="0 0 74 74"
      fill="none"
    >
      <path
        opacity="0.45"
        d="M36.6362 73.2172C56.8699 73.2172 73.2724 56.827 73.2724 36.6086C73.2724 16.3902 56.8699 0 36.6362 0C16.4026 0 0 16.3902 0 36.6086C0 56.827 16.4026 73.2172 36.6362 73.2172Z"
        fill="#E7E7E7"
      />
      <path
        d="M41.5286 19.8061C41.5286 19.8061 42.5908 24.9222 42.1287 28.4621C42.0837 28.8052 41.9711 29.136 41.7974 29.4354C41.6238 29.7348 41.3926 29.997 41.1171 30.2066C40.8415 30.4163 40.5272 30.5694 40.1922 30.6571C39.8572 30.7448 39.5081 30.7654 39.1651 30.7176C37.3859 30.4629 35.049 29.5925 34.1461 26.923L32.0535 22.5711C32.0535 22.5711 30.8426 19.8008 33.5194 17.3489C36.1962 14.897 41.0346 16.6537 41.5286 19.8061Z"
        fill="#A0A0A0"
      />
      <path
        d="M32.4352 23.3618L31.7554 40.4773L41.2198 40.1748L37.911 27.841L32.4352 23.3618Z"
        fill="#A0A0A0"
      />
      <path
        d="M40.2908 20.1723C38.6928 20.4242 37.0711 20.4918 35.4576 20.374C36.005 21.0235 36.35 21.8189 36.45 22.6621C36.5501 23.5052 36.4008 24.3592 36.0206 25.1186C35.6677 25.8626 35.0663 26.4604 34.3198 26.8091C33.5734 27.1578 32.7287 27.2356 31.931 27.0291L31.2247 20.3528C31.0893 19.4005 31.2154 18.4294 31.5896 17.5432C31.9638 16.657 32.572 15.8891 33.3491 15.3216C34.0191 14.8283 34.7199 14.3781 35.447 13.9736C37.2794 12.9758 40.227 13.9205 41.8204 12.4239C41.9784 12.2739 42.1727 12.1675 42.3843 12.1151C42.5959 12.0627 42.8174 12.0661 43.0273 12.1249C43.2372 12.1837 43.4281 12.296 43.5815 12.4508C43.7349 12.6055 43.8455 12.7974 43.9024 13.0077C44.4335 14.9979 44.46 18.2352 41.8469 19.6681C41.3599 19.9215 40.8339 20.0919 40.2908 20.1723Z"
        fill="#707070"
      />
      <path
        d="M36.5343 24.901C36.5343 24.901 36.2581 22.9056 34.771 23.2399C33.2839 23.5743 33.6716 26.456 35.743 26.4826L36.5343 24.901Z"
        fill="#A0A0A0"
      />
      <path
        d="M42.0325 23.0649L43.7161 24.8906C43.8109 24.9946 43.878 25.1207 43.9112 25.2574C43.9444 25.3941 43.9427 25.5369 43.9062 25.6727C43.8697 25.8086 43.7996 25.933 43.7023 26.0347C43.6051 26.1364 43.4838 26.212 43.3496 26.2545L41.4058 26.8649L42.0325 23.0649Z"
        fill="#A0A0A0"
      />
      <path
        opacity="0.31"
        d="M38.7486 30.5104C37.5503 30.3536 36.4241 29.85 35.5088 29.0615C35.5088 29.0615 36.0399 32.1556 39.7949 34.8198L38.7486 30.5104Z"
        fill="#707070"
      />
      <path
        d="M11.9552 63.6643C11.9552 63.6643 11.3922 40.6844 36.1952 39.4956C60.9982 38.3068 60.3449 64.6779 60.3449 64.6779C60.3449 64.6779 36.9441 85.9914 11.9552 63.6643Z"
        fill="#CFCFCF"
      />
    </SvgIcon>
  );
};
